import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { DisabledAgentsContent } from "../ConfirmSubmitWorkflowModal/DisabledAgentsContent";

interface AgentActiveCheckResponse {
  enabled: boolean;
  id: number;
  name: string;
}

interface DisabledAgentsContentProps {
  disabledAgents: AgentActiveCheckResponse[];
  variant?: "edit" | "cancel";
}

export const MODAL_RESULT = {
  DISMISSED: "dismissed",
  ERROR: "error",
  SUCCESS: "closed_after_success",
} as const;

export const DisabledAgentsInWorkflowsModal = ({
  disabledAgents,
  variant = "edit",
}: DisabledAgentsContentProps) => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.resolve(MODAL_RESULT.DISMISSED);
        void modal.hide();
      }}
    >
      <Modal.Overlay />
      <DisabledAgentsContent
        variant={variant}
        disabledAgents={disabledAgents}
        onPublish={() => {
          modal.resolve(MODAL_RESULT.SUCCESS);
          void modal.hide();
        }}
        onCancel={() => {
          modal.resolve(MODAL_RESULT.DISMISSED);
          void modal.hide();
        }}
      />
    </Modal>
  );
};

const DisabledAgentsModal = ModalManager.create(
  ({
    disabledAgents,
    variant,
  }: {
    disabledAgents: AgentActiveCheckResponse[];
    variant?: "edit" | "cancel";
  }) => (
    <DisabledAgentsInWorkflowsModal
      disabledAgents={disabledAgents}
      variant={variant}
    />
  ),
);

export const useDisabledAgentsModal = () => {
  const modal = useModal(DisabledAgentsModal);
  return {
    modal,
    isDisabledAgentsModalVisible: modal.visible,
  };
};
